// eslint-disable-next-line @typescript-eslint/naming-convention
export enum UNBUNDLING_TYPES {
    TOTAL = 'DT',
    PARTIAL = 'DP',
}

export enum ProductTypes {
    PRO = 'offre_pro',
}

export interface IFaiBox5gResult {
    eligibilite5gBox: boolean;
    homeZone: string;
    idOffres: string[];
}

export interface IFaiBoxResult {
    eligibiliteTokyo: boolean;
    homeZone: string;
    idOffres: string[];
    eligibilite5gBox?: IFaiBox5gResult;
}

export interface IFaiData {
    eligibility4g: IFaiBoxResult;
    userAddress: IFaiAddressInstallation;
    eligibility: IEligibilityResult;
}

export interface IFaiAddressInstallation {
    codePostal: string;
    codeInsee: string;
    codeVoie: string;
    numeroVoie: string;
    voie: string;
    listeRouge: boolean;
    commune: string;
    complementVoie?: string;
}

export interface IFtthSliderItem {
    label: string;
    iconName?: string;
}

export interface IEligibility {
    cartId: string;
    address: IAddress;
    buildings?: IBuilding[];
    shouldBypass?: boolean;
    pto?: string;
    technicalInfos?: ITechnicalInfos[];
    hasFTTHEligibility?: boolean;
    xDSLtechnoSpeed?: {
        speedDown: number;
        speedUp: number;
    };
    homeZone?: {
        box4g: string;
        box5g: string;
    };
    isCdl: boolean;
}

export interface ITechno {
    speedDown: number;
    speedUp: number;
    technoType: string;
    offers: string[];
}

export interface IFtthTechno extends ITechno {
    buildings?: IBuilding[];
    shouldBypass?: boolean;
}

export interface IAddress {
    zipCode: string;
    id?: string; // idAddressBytel
    hexaKey?: string;
    city: {
        label: string;
        INSEECode: string;
    };
    street: {
        label: string;
        rivoliCode: string;
    };
    streetNumber: {
        label: string;
        // eslint-disable-next-line id-denylist
        number: string;
        complement?: string;
    };
}

export interface IEligibilityResult {
    idPanier: string;
    technicalAddress: IAddress;
    shouldBypass?: boolean;
    offersWithOptions: { idOffer: string; options: string[] }[];
    results: {
        xdsl?: IEligibilityTechno;
        ftth?: IEligibilityFtthTechno;
        box4g?: IEligibilityTechno;
        box5g?: IEligibilityTechno;
    };
    housing?: EligibilityHousing;
    techno: string;
}

export interface EligibilityHousing {
    NDRouting?: string;
    accessStatusDSL?: string;
    accessStatusFTTH?: string;
    predecessorName?: string;
    status?: string;
}

export interface IEligibilityTechno {
    offers: string[];
    speedDown: number;
    speedUp: number;
    technoType: string;
    homeZone?: string;
}

export interface IEligibilityFtthTechno {
    buildings?: IBuilding[];
    shouldBypass?: boolean;
    pto?: string;
    pmLocationType?: string;
    housingType?: string;
    groupeCategorieRaccoLogement?: string;
    status?: boolean;
}

export interface IBuilding {
    building: string;
    idPm?: string;
    type: string;
    stairs: IStair[];
}

export interface IStair {
    stair: string;
    stages: IStage[];
}

export interface IStage {
    floor: string;
    nbActiveLine?: number;
    nbBuildLine?: number;
    nbPremises?: number;
    ptos: IPTO[];
    ptoRequired: boolean;
}

export interface IPTO {
    pto: string;
    lineStatus: string;
}

export interface IFaiVerticalStructure {
    building: string;
    stair: string;
    floor: string;
    hasPto: boolean;
}

export interface ITechnicalInfos {
    type: string;
    valeur: string;
}
